export default function isKeyboardEvent (eventName) {
	return [
		'keydown',
		'keypress',
		'keyup'
	].some(keyboardEvent => eventName === keyboardEvent || eventName === `on${keyboardEvent}`);
};
